import { Grid, Typography, CircularProgress } from "@mui/material";
import PDialog from "../../../components/pos/PDialog";
import React, { useEffect, useState } from "react";
import PSelect from "../../../components/pos/PSelect";
import { useTranslation } from "react-i18next";
import PText from "../../../components/pos/PText";
import PDatePicker from "../../../components/pos/PDatePicker";
import API from "../../../utils/API";
import { SyncUtils } from "../../../utils/SyncUtils";
import PConfirm from "../../../components/pos/PConfirm";

export default function PendingChequeCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [voucherNumber, setVouchernumber] = useState("");
  const [transactionDate, setTransactiondate] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [chequeDateError, setChequeDateError] = useState("");
  const [checkNo, setCheckNo] = useState("");
  const [origObject, setOrigObject] = useState(null);
  const [windowTitle, setWindowTitile] = useState("");
  const [amount, setAmount] = useState("");
  const [account, setAccount] = useState("");
  const [customer, setCustomer] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [liveValidation, setLiveValidation] = useState(false);
  const [dynamicLabelOne, setDynamicLabelOne] = useState("");
  const [dynamicLabelTwo, setDynamicLabelTwo] = useState("");

  useEffect(() => {
    if (props.selectedRow) {
      populateTransactions();
      dynamicLabel();
    }
  }, [props.selectedRow]);

  useEffect(() => {
    if (liveValidation && chequeDate === "") {
      setChequeDateError(translate("Cheque Date is Required"));
    } else {
      setChequeDateError("");
    }
  }, [chequeDate]);

  function dynamicLabel() {
    switch (props.selectedRowType) {
      case "Payment":
        setDynamicLabelOne("From Account");
        setDynamicLabelTwo("To Account");
        break;
      case "Receipt":
        setDynamicLabelOne("From Account");
        setDynamicLabelTwo("To Account");
        break;
      case "CUSTOMER":
        setDynamicLabelOne("Customer");
        setDynamicLabelTwo("Account");
        break;
      case "VENDOR":
        setDynamicLabelOne("Account");
        setDynamicLabelTwo("Vendor");
        break;
    }
  }

  function validate() {
    let flag = true;
    if (!chequeDate || chequeDate === "") {
      setChequeDateError(translate("Cheque Date is Required"));
      flag = false;
    }
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  async function populateTransactions() {
    {
      try {
        let { data } = await API.get(
          "/api/v1/accounting/transaction/" + props.selectedRow
        );
        setOrigObject(data);
        populateData(data);
        setWindowTitile(data.voucherNumber);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Transactions data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setVouchernumber(bean.voucherNumber);
    setTransactiondate(bean.transactionDate2);
    setChequeDate(bean.chequeDate);
    setCheckNo(bean.chequeNo);
    setAmount(bean.amount);
    setAccount(bean.toLedgerName);
    setCustomer(bean.fromLedgerName);
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.put(
          "/api/v1/accountingtransaction/" + origObject.id,
          payload
        );
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        showProgress(false, "Saving");
        props.onRefresh();
        onCloseWindow();
      } catch (err) {
        console.log("err", err);
        props.showMessage("error", translate("Not able to Save Transactions"));

        showProgress(false, "Saving");
      }
    } else {
      console.log("Save cannot be completed...");
    }
  }

  async function onPostClicked() {
    if (validate()) {
      setConfirmContext({
        title: translate("Are You Sure"),
        message: translate(
          "Are you sure to post the transaction,This action can't revert!"
        ),
        type: "warning",
        open: true,
        yes: true,
        no: true,
      });
      setConfirmOpen(true);
    }
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["chequeStatus"] = "CLEARED";
    saveObject["chequeDate"] = chequeDate;
    return saveObject;
  }

  function onCloseWindow() {
    props.setShowCrud(false);
  }

  const content = (
    <div>
      <Grid container spacing={10}>
        <Grid item xs={18}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="50%">
                  <Typography variant="body1">
                    {translate("Voucher Number")}
                  </Typography>
                </td>
                <td width="80%">
                  <PText
                    value={voucherNumber}
                    // onChange={(e) => setVouchernumber(e.target.value)}
                    InputProps={{ readOnly: true }}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Transaction Date")}
                  </Typography>
                </td>
                <td>
                  <PDatePicker
                    value={transactionDate}
                    type="date"
                    InputProps={{ readOnly: true }}
                    onChange={(e) => {
                      let d = new Date();
                      e.$d.setHours(d.getHours());
                      e.$d.setMinutes(d.getMinutes());
                      e.$d.setSeconds(d.getSeconds());
                      setTransactiondate(e.$d.toISOString());
                    }}
                    // onChange={(e) => setTransactiondate(e.$d.toISOString())}
                  ></PDatePicker>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {props.selectedRowType == "VENDOR"
                      ? dynamicLabelTwo
                      : dynamicLabelOne}
                  </Typography>
                </td>
                {props.selectedRowType == "VENDOR" ? (
                  <td>
                    <PText
                      value={account}
                      // onChange={(e) => setVouchernumber(e.target.value)}
                      InputProps={{ readOnly: true }}
                    ></PText>
                  </td>
                ) : (
                  <td>
                    <PText
                      value={customer}
                      // onChange={(e) => setVouchernumber(e.target.value)}
                      InputProps={{ readOnly: true }}
                    ></PText>
                  </td>
                )}
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {props.selectedRowType == "VENDOR"
                      ? dynamicLabelOne
                      : dynamicLabelTwo}
                  </Typography>
                </td>
                {props.selectedRowType == "VENDOR" ? (
                  <td>
                    <PText
                      value={customer}
                      // onChange={(e) => setVouchernumber(e.target.value)}
                      InputProps={{ readOnly: true }}
                    ></PText>
                  </td>
                ) : (
                  <td>
                    <PText
                      value={account}
                      // onChange={(e) => setVouchernumber(e.target.value)}
                      InputProps={{ readOnly: true }}
                    ></PText>
                  </td>
                )}
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Cheque No")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={checkNo}
                    InputProps={{ readOnly: true }}
                    // onChange={(e) => setCheckNo(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Cheque Date")}
                  </Typography>
                </td>
                <td>
                  <PDatePicker
                    value={chequeDate}
                    type="date"
                    error={chequeDateError}
                    InputProps={{ readOnly: true }}
                    onChange={(e) => {
                      let d = new Date();
                      e.$d.setHours(d.getHours());
                      e.$d.setMinutes(d.getMinutes());
                      e.$d.setSeconds(d.getSeconds());
                      setChequeDate(e.$d.toISOString());
                    }}
                  ></PDatePicker>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Amount")}</Typography>
                </td>
                <td>
                  <PText
                    value={amount}
                    InputProps={{ readOnly: true }}
                    // onChange={(e) => setCheckNo(e.target.value)}
                  ></PText>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div>
      <PDialog
        content={content}
        title={windowTitle}
        maxWidth={"md"}
        fullWidth={true}
        open={true}
        hideSave={false}
        saveLabel="Post"
        onCloseWindow={onCloseWindow}
        onSave={onPostClicked}
        mode={
          props.chequeStatus == "CLEARED" ||
          !props.context.privileges.post_pending_cheques
            ? "view"
            : "create"
        }
      ></PDialog>
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
}
